module.exports = __webpack_public_path__ + "img/thumb_32.65b06672.jpg";